import { UrlParamKeyValuePair } from '../models/url-param-key-value-pair';

export const buildQueryFromKeyValuePairs = (pairs: UrlParamKeyValuePair[]): string => {
  return pairs
    .filter(({ value }) => {
      return (
        (typeof value === 'string' && !!value) ||
        typeof value === 'number' ||
        typeof value === 'boolean'
      );
    })
    .map(({ key, value, transform }) => `${key}=${transform ? transform(value) : value}`)
    .join('&');
};
